import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Clock, ArrowUpRight } from "lucide-react";
import { useLang } from "@/i18n";
import { articles } from "@/blogData";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ChatWidget from "@/components/ChatWidget";
import { Reveal } from "@/components/Reveal";

export default function BlogPage() {
  const { lang, t } = useLang();

  useEffect(() => {
    document.title = lang === "fr"
      ? "Conseils locations saisonnières & nettoyage Airbnb à Nice — Service Plus"
      : "Vacation rental & Airbnb cleaning tips in Nice — Service Plus";
    window.scrollTo(0, 0);
  }, [lang]);

  return (
    <main>
      <Navbar />
      <section className="bg-[#0E1B2A] pb-20 pt-36">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#D4AF37]">{t.blog.overline}</p>
          <h1 data-testid="blog-page-title" className="mt-4 max-w-3xl font-serif text-4xl sm:text-5xl font-medium leading-tight text-[#FAF8F5]">
            {t.blog.title}
          </h1>
          <p className="mt-4 max-w-xl text-base sm:text-lg text-[#FAF8F5]/65">{t.blog.sub}</p>
        </div>
      </section>

      <section className="bg-[#FAF8F5] py-20">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <div className="grid gap-7 md:grid-cols-3">
            {articles.map((a, i) => (
              <Reveal key={a.slug} delay={i * 0.08}>
                <Link
                  data-testid={`blog-page-card-${a.slug}`}
                  to={`/blog/${a.slug}`}
                  className="group flex h-full flex-col overflow-hidden rounded-2xl border border-[#0E1B2A]/8 bg-white shadow-[0_10px_30px_rgba(14,27,42,0.04)] transition-all duration-500 hover:-translate-y-1.5 hover:shadow-[0_25px_50px_-15px_rgba(14,27,42,0.18)]"
                >
                  <div className="h-52 overflow-hidden">
                    <img
                      src={a.image}
                      onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = a.fallback; }}
                      alt={a[lang].title}
                      className="h-full w-full object-cover transition-transform duration-[1.2s] group-hover:scale-110"
                    />
                  </div>
                  <div className="flex flex-1 flex-col p-7">
                    <p className="flex items-center gap-2 text-xs uppercase tracking-widest text-[#94A3B8]">
                      <Clock size={12} />
                      {a.readTime} {t.blog.min}
                    </p>
                    <h2 className="mt-3 font-serif text-xl font-semibold leading-snug text-[#0E1B2A] transition-colors group-hover:text-[#C87A57]">
                      {a[lang].title}
                    </h2>
                    <p className="mt-3 flex-1 text-sm leading-relaxed text-[#475569]">{a[lang].excerpt}</p>
                    <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-[#2C5E7A]">
                      {t.blog.read}
                      <ArrowUpRight size={15} />
                    </span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <Footer />
      <ChatWidget />
    </main>
  );
}
